import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell, Field, inputCls, submitCls } from "@/components/AuthShell";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

const linkCls = "font-semibold text-[#8B3A2B] underline-offset-4 hover:underline";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(token ? "" : t.auth.badLink);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { setError(t.auth.mismatch); return; }
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      toast.success(t.auth.resetDone);
      nav("/login", { replace: true });
    } catch (err) {
      const s = err?.response?.status;
      setError(s === 400 ? t.auth.badLink : s === 422 ? t.auth.invalid : t.auth.error);
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <AuthShell title={t.auth.resetTitle} subtitle={t.auth.resetSub}
      footer={<Link to="/forgot-password" className={linkCls} data-testid="reset-to-forgot">{t.auth.forgot}</Link>}>
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <Field label={t.auth.newPassword}>
          <input type="password" required minLength={6} dir="ltr" className={inputCls} value={form.password} onChange={set("password")} data-testid="reset-password-input" />
        </Field>
        <Field label={t.auth.confirmPassword}>
          <input type="password" required minLength={6} dir="ltr" className={inputCls} value={form.confirm} onChange={set("confirm")} data-testid="reset-confirm-input" />
        </Field>
        {error && <p className="text-sm text-red-800 bg-red-50 border border-red-200 p-3" data-testid="reset-error">{error}</p>}
        <button disabled={loading || !token} className={submitCls} data-testid="reset-submit">{loading ? t.auth.sending : t.auth.saveNew}</button>
      </form>
    </AuthShell>
  );
}
